import React, { useMemo, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TocStockHeader from "../../CommonTocComponent/TocHeader/TocStockHeader";
import SingleHeadingText from "../../CommonTocComponent/TocHeader/SingleHeadingText";
import SelectSchemeData from "./SelectSchemeData";
import { Col, Row } from "react-bootstrap";
import { EMutualFundFlow } from "../MutualFund";
const SelectScheme = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const device = DeviceContext();
    const schemeData = useMemo(() => {
        var _a, _b, _c;
        let schemeType = {};
        let returnType = [];
        let divFrequency = {};
        (_c = (_b = (_a = props.mfData) === null || _a === void 0 ? void 0 : _a.ascSchemes) === null || _b === void 0 ? void 0 : _b.lstTyp) === null || _c === void 0 ? void 0 : _c.map((x) => {
            if (!divFrequency.hasOwnProperty(x.nm)) {
                divFrequency[x.nm] = {};
            }
            x.lstPlan.map((z) => {
                if (divFrequency.hasOwnProperty(x.nm)) {
                    if (!divFrequency[x.nm].hasOwnProperty(z.nm)) {
                        if (divFrequency[x.nm][z.nm] === undefined) {
                            divFrequency[x.nm][z.nm] = [];
                        }
                        if (!divFrequency[x.nm][z.nm].find((q) => q.value === z.frq))
                            divFrequency[x.nm][z.nm].push({ title: z.frq, value: z.frq });
                    }
                    else {
                        if (!divFrequency[x.nm][z.nm].find((q) => q.value === z.frq))
                            divFrequency[x.nm][z.nm].push({ title: z.frq, value: z.frq });
                    }
                }
                if (schemeType.hasOwnProperty(x.nm)) {
                    if (schemeType[x.nm] !== undefined) {
                        if (!schemeType[x.nm].find((x) => x.value === z.nm)) {
                            schemeType[x.nm].push({ title: z.nm, value: z.nm });
                        }
                    }
                }
                else {
                    schemeType[x.nm] = [{ title: z.nm, value: z.nm }];
                }
            });
            returnType.push({ title: x.nm, value: x.nm });
        });
        return { schemeType, returnType, divFrequency };
    }, [props.mfData]);
    const [selectedScheme, setSelectedScheme] = useState({
        schemeType: schemeData.schemeType[(_a = props.mfData) === null || _a === void 0 ? void 0 : _a.schemetype][0].value,
        returnType: (_b = props.mfData) === null || _b === void 0 ? void 0 : _b.schemetype,
        divFrequency: (_c = props.mfData) === null || _c === void 0 ? void 0 : _c.divFrq,
    });
    const apply = () => {
        let scriptDetails = props.mfData.ascSchemes.lstTyp.find((x) => x.nm === selectedScheme.returnType)
            .lstPlan.find((z) => z.nm === selectedScheme.schemeType && z.frq === selectedScheme.divFrequency);
        props.setISIN(scriptDetails.isin);
        props.setCatDetails({
            category: scriptDetails.catName,
            subCategory: scriptDetails.subCatName
        });
        props.setShow(EMutualFundFlow.PURCHASE);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Select Scheme and Return Type" }) }),
            React.createElement("div", { className: "overflow-scroll-400 cust-scroll-bar" },
                React.createElement(SelectSchemeData, { stockTitle: (_d = props.mfData) === null || _d === void 0 ? void 0 : _d.schemename, stockType: (_e = props.mfData) === null || _e === void 0 ? void 0 : _e.schemetype, navDate: (_f = props.mfData) === null || _f === void 0 ? void 0 : _f.timestamp, schemeData: schemeData, ltp: (_g = props.mfData) === null || _g === void 0 ? void 0 : _g.nav, change: (_h = props.mfData) === null || _h === void 0 ? void 0 : _h.changeinnav, changePerc: (_j = props.mfData) === null || _j === void 0 ? void 0 : _j.changeinnavper, selectedScheme: selectedScheme, setSelectedScheme: setSelectedScheme })),
            React.createElement("div", { className: "toc-close-button" },
                React.createElement(Row, { className: "bottombtnsection bg-white" },
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: () => props.setShow(EMutualFundFlow.PURCHASE) })),
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => apply() })))))) : (React.createElement(GenericDrawer, { show: props.show, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
                React.createElement("label", { className: "ps-3 DMSan_16_700 txt_blackOne1 pb-4" }, "Select Scheme and Return Type")), bodyComp: React.createElement(React.Fragment, null,
                React.createElement("div", { className: "overflow-scroll-400 cust-scroll-bar" },
                    React.createElement(SelectSchemeData, { stockTitle: (_k = props.mfData) === null || _k === void 0 ? void 0 : _k.schemename, stockType: (_l = props.mfData) === null || _l === void 0 ? void 0 : _l.schemetype, navDate: (_m = props.mfData) === null || _m === void 0 ? void 0 : _m.timestamp, schemeData: schemeData, ltp: (_o = props.mfData) === null || _o === void 0 ? void 0 : _o.nav, change: (_p = props.mfData) === null || _p === void 0 ? void 0 : _p.changeinnav, changePerc: (_q = props.mfData) === null || _q === void 0 ? void 0 : _q.changeinnavper, selectedScheme: selectedScheme, setSelectedScheme: setSelectedScheme })),
                React.createElement(Row, { className: "bottombtnsection mb-2 pb-2 pt-3 bg-white px-2" },
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: () => props.setShow(EMutualFundFlow.PURCHASE) })),
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => apply() })))) })))));
};
export default SelectScheme;
